import {message} from 'antd'
import {auth} from './firebase'

declare global {
    interface Window {
        env: {
            BACKEND_URL?: string
        }
    }
}

class HTTPError extends Error {
    constructor(public response: Response) {
        super(`${response.status} ${response.statusText}`)
        this.name = 'HTTPError'
    }
}

const getBackendUrl = () => {
    const url = new URL(window.location.href)
    let newUrl = url.protocol + '//' + url.host

    if (url.protocol === 'http:') {
        newUrl = 'http://127.0.0.1:8000'
    } else {
        newUrl = newUrl + '/api'
    }

    console.log('backendUrl:', newUrl)
    return newUrl
}

const backendUrl = getBackendUrl()

export async function fetchBackend(
    endpoint: string,
    init: any = {}
) {
    console.log('fetchBackend')
    try {
        console.log({backendUrl})
        const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
        const url = `${backendUrl}/${cleanEndpoint}`
        const url_verify_connection = `${backendUrl}/verify_connection`
        console.log({url})
        const newInit = {
            ...init,
            headers: {
                ...init.headers,
                frontend: 'true'
            }
        }

        const timeout = new Promise((resolve, reject) => {
            setTimeout(reject, 500, 'Can not connect to the backend server.')
        })

        await Promise.race([
            fetch(url_verify_connection),
            timeout
        ])
        const response = await fetch(
            url,
            newInit
        )

        if (!response.ok) {
            throw new HTTPError(response)
        }
        console.log('response', cleanEndpoint, {response})
        const data = await response.json()
        console.log('data', cleanEndpoint, {data})
        return data
    } catch (error) {
        message.error('There has been a problem with the backend.')
        console.error(error)
        return null
    }
}

export async function fetchBackendToken(
    endpoint: string,
    init: any = {}
) {
    const token = await auth.currentUser?.getIdToken()
    // console.log({token})
    // const email = auth.currentUser?.email
    // console.log({email})
    const newInit = {
        ...init,
        headers: {
            ...init.headers,
            token
        }
    }
    const data = await fetchBackend(endpoint, newInit)
    return data
}

export async function* fetchBackendStream(
    endpoint: string,
    init: any = {}) {
    const data = await fetchBackend(endpoint, init)
    yield data
}

export async function* fetchBackendTokenStream(
    endpoint: string,
    init: any = {}) {
    const data = await fetchBackendToken(endpoint, init)
    yield data
}
